import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg48Login = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "m25.587 3.308.146.031 12 2.988a2 2 0 0 1 1.51 1.78l.007.161v30.464a2 2 0 0 1-1.362 1.896l-.155.045-12 2.988q-.238.06-.483.06a2 2 0 0 1-1.995-1.851l-.005-.15V5.28q0-.245.06-.483a2 2 0 0 1 2.277-1.489M10 29.25a.75.75 0 0 1 .743.648l.007.102v9l.006.128c.06.588.528 1.056 1.116 1.116l.128.006h9l.102.007a.75.75 0 0 1 0 1.486L21 41.75h-9l-.168-.005a2.75 2.75 0 0 1-2.577-2.57L9.25 39v-9l.007-.102A.75.75 0 0 1 10 29.25m4.811-11.103.085.073 4.859 4.859a.75.75 0 0 1 .072.976l-.072.084-4.86 4.86a.75.75 0 0 1-1.133-.977l.073-.084 3.579-3.58H9.75a.75.75 0 0 1-.102-1.492l.102-.007 7.662-.001-3.577-3.578a.75.75 0 0 1-.073-.976l.073-.084a.75.75 0 0 1 .976-.073M27 21.104a.75.75 0 0 0-.743.648l-.007.102v4.294a.75.75 0 0 0 1.493.101l.007-.101v-4.294a.75.75 0 0 0-.75-.75M21 5.25a.75.75 0 0 1 .102 1.493L21 6.75h-9a1.25 1.25 0 0 0-1.244 1.122L10.75 8v9a.75.75 0 0 1-1.493.102L9.25 17V8a2.75 2.75 0 0 1 2.582-2.745L12 5.25z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg48Login$1 = Svg48Login;

export { Svg48Login$1 as default };
